const GA_MEASUREMENT_ID = "G-ZETG5SB1D0";

export const trackEvent = (eventName, parameters = {}) => {
  if (typeof window === "undefined" || typeof window.gtag !== "function") {
    return;
  }

  window.gtag("event", eventName, {
    send_to: GA_MEASUREMENT_ID,
    ...parameters,
  });
};

export const getLinkDomain = (href) => {
  try {
    return new URL(href).hostname;
  } catch {
    return "";
  }
};

export const trackOutboundLink = (href, label, extraParameters = {}) => {
  trackEvent("click", {
    link_url: href,
    link_domain: getLinkDomain(href),
    link_text: label,
    outbound: true,
    ...extraParameters,
  });
};

export const trackProductSelection = (product) => {
  trackEvent("select_item", {
    item_list_name: "OBB Zeronimo allocation",
    items: [
      {
        item_id: String(product.id || product.name),
        item_name: product.name,
        item_brand: "Zeronimo",
        item_category: "Non-alcoholic wine",
        price: Number(String(product.price || "").replace(/[^0-9.]/g, "")) || undefined,
      },
    ],
  });
};

export const trackCheckoutIntent = ({ href, label, product }) => {
  trackEvent("begin_checkout_intent", {
    link_url: href,
    link_domain: getLinkDomain(href),
    link_text: label,
    value: Number(String(product?.price || "").replace(/[^0-9.]/g, "")) || undefined,
    currency: "USD",
  });
};
